<!-- 要求 ng-bootstrap version >=4.1.0 -->
<div class="dataTables_wrapper container-fluid" style="padding-left:0px;padding-right:0px;">
  <div class="rowCard">
    <div class="dataTables_paginate paging_full_numbers">
      <ul *ngIf="pager.Pages && pager.Pages.length" class="pagination">
        <li class="sm-page-item first-item" [ngClass]="{disabled:pager.CurrentPage === 1}">
          <a class="page-link" (click)="pagerSetting(1)">First</a>
        </li>
        <li class="sm-page-item previous-item" [ngClass]="{disabled:pager.CurrentPage === 1}">
          <a class="page-link" (click)="pagerSetting(pager.CurrentPage - 1)">Prev</a>
        </li>
        <li class="sm-page-item active number-item">
          <a class="page-link" href="javascript:void(0)"><span
              style="font-size:0.5rem">{{pager.CurrentPage}}/{{pager.TotalPages}}</span></a>
        </li>
        <li class="sm-page-item next-item" [ngClass]="{disabled:pager.CurrentPage === pager.TotalPages}">
          <a class="page-link" (click)="pagerSetting(pager.CurrentPage + 1)">Next</a>
        </li>
        <li class="sm-page-item last-item" [ngClass]="{disabled:pager.CurrentPage === pager.TotalPages}">
          <a class="page-link" (click)="pagerSetting(pager.TotalPages)">Last</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="dataTb">
    <div class="row">
      <div class="col-md-4 dataTb">
        <div class="dataTables_info">
          {{ description }}
        </div>
      </div>
      <div class="col-md-5">
        <div class="dataTables_paginate paging_full_numbers">
          <ul *ngIf="pager.Pages && pager.Pages.length" class="pagination">
            <li class="page-item first-item" [ngClass]="{disabled:pager.CurrentPage === 1}">
              <a class="page-link" (click)="pagerSetting(1)">First</a>
            </li>
            <li class="page-item previous-item" [ngClass]="{disabled:pager.CurrentPage === 1}">
              <a class="page-link" (click)="pagerSetting(pager.CurrentPage - 1)">Previous</a>
            </li>
            <li class="page-item number-item" *ngFor="let page of pager.Pages"
              [ngClass]="{active:pager.CurrentPage === page}">
              <a class="page-link" (click)="pagerSetting(page)">{{page}}</a>
            </li>
            <li class="page-item next-item" [ngClass]="{disabled:pager.CurrentPage === pager.TotalPages}">
              <a class="page-link" (click)="pagerSetting(pager.CurrentPage + 1)">Next</a>
            </li>
            <li class="page-item last-item" [ngClass]="{disabled:pager.CurrentPage === pager.TotalPages}">
              <a class="page-link" (click)="pagerSetting(pager.TotalPages)">Last</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="dataTb" style="position:absolute;right:1.25rem;">
        <div class="dataTables_length" style="display: inline-block;vertical-align: middle;">

          Show
          <ng-select [searchable]="false" [items]="pageOptions" bindLabel="name" [clearable]="false"
            [(ngModel)]="selectedSize" (ngModelChange)="changePageSize()"
            style="min-width:55px;vertical-align: middle;">
          </ng-select>
          entries
        </div>
      </div>
    </div>
  </div>
</div>
